import React from 'react';
import { Menu, Dropdown, Icon, message, Upload, Button,Modal, Spin } from 'antd';
import { Link } from 'react-router-dom';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import { contractType,contractSource, dicRentContractSignStatus, dicRentContractRentStatus, dicRentContractSettlementStatus,syncStatusIsMap } from '../../axios/dictionaries';
import AddBill from './components/List/AddBill';
import CheckOut from './components/List/CheckOut';
import Delete from './components/List/Delete';
import Details from './components/List/details/index';
import { uploadEnclosure,postFrom, config, transterQuery } from '../../axios';
import moment from 'moment';
import { moneyAddComma, handleExportParams,isPlatform } from '../../utils/index';
import axios from 'axios';
import JrApiLog from "../Other/JrApiLog";
import LeaseSigning from '../../containers/LeaseSigning';

export default class Page extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            params: {
                beginDateStart: "",
                beginDateEnd: "",
                createTimeStart: "",
                createTimeEnd: "",
                endDateStart: "",
                endDateEnd: "",
                factEndDateStart: "",
                factEndDateEnd: "",
                buildingName: "",
                keyword: "",
                merchantName: "",
                pageSize: 10,
                projectName: "",
                rentStatus: 1,
                roomNo: "",
                settlementStatus: "",
                signStatus: "",
                houseId: "",
            }, //搜索参数
            merchantId: '', //商户id
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            showAddBillModal: false, //添加账单
            inputSearchTerm: "170px", //查询条件宽度
            showCheckOutModal: false, //退租
            showDeleteModal: false, //删除
            dateChioseNumberStart: '', //日期选择对应开始字段
            dateChioseNumberEnd: '', //日期选择对应结束字段
            DateType: '', //日期类别
            showAddModal: false,
            tableTotalMny: 0, //总金额

            showLogImportModal:false,  //批量导入合同弹窗
            logImporLoad:false,       //批量导入合同Loading
            logImportData:'' ,     //批量导入合同 数据显示

            showBillImportModal:false,  //批量导入账单弹窗
            billImporLoad:false,       //批量导入账单Loading
            billImportData:''      //批量导入账单 数据显示
        }
        this.logTimer = null
        this.billTimer = null
    }

    componentDidMount() {
        this.setLocationSearchToParam().then(()=> {
            this.handleSearch();
        })
    }
    setLocationSearchToParam = () => {
        return new Promise(resolve => {
            const { state } = this.props.location 
            if(state && state.houseId) {
                this.setState(_state => {
                    _state.params.houseId = state.houseId
                    return _state
                },resolve)
            }else {
                resolve()
            }
        })
    }

    handleJrApiLogInfo(tableName,id) {
        //console.log(this);
        this.jrApiLogRef.open(tableName,id);
    }

    handleSearch = (values = {}) => { //表单搜索/分页
        let { params, current, merchantId } = this.state;
        let data = {};
        if (values.current) {
            data = Object.assign({}, params, values, { merchantId });
        } else {
            data = Object.assign({}, params, values, { current, merchantId });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        axios.all([
            postFrom({ url: config.API_rentcontract_findExpireRentContractPageList, data }),
            postFrom({ url: config.API_rentcontract_findExpireRentContractCount, data }),
        ]).then(axios.spread((listRes, countRes) => {
            this.setState({ tableTotalMny: countRes.rentContractTotalMoney, tableTotal: listRes.total, current: listRes.current, tableData: listRes.records, tableLoading: false });
        })).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        })
    }

    handleAddBill = (id) => { //添加账单
        this.setState({ showAddBillModal: true });
        this.addBillRef.loadPack({ id })
    }

    handleRenewal = (row) => { // 续签
        this.LeaseSigningRef.loadPack(row)
    }

    handleCheckOut = (id) => { //退租
        this.checkOutRef.loadPack({ id });
        this.setState({ showCheckOutModal: true });
    }

    handleDelete = (id) => { //删除
        this.setState({ showDeleteModal: true });
        this.deleteRef.loadPack({ id });
    }

    hangleWatchDetail = ({ id }) => { //详情

        this.setState({ showAddModal: true });
        this.ListDetailsRef.loadPack({ id });
    }

    handleSendMessage = (e, id) => { //发送短信
        this.setState({ loading: true });
        postFrom({ url: config.API_rentcontract_sendSignSms, data: { rentContractId: id } }).then(res => {
            message.success('发送成功');
            this.setState({ loading: false });
            this.handleSearch();
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        });
    }

    handleJrApiLogInfo = (tableName,id) => {
        this.jrApiLogRef.open(tableName,id);
    }

    handleRangeDate = (e) => { //选择日期类型
        this.setState({ DateType: e });
        switch (e) {
            case 1: //合同起租日
                this.setState({
                    dateChioseNumberStart: "beginDateStart",
                    dateChioseNumberEnd: "beginDateEnd"
                });
                break;
            case 2: //合同退租日
                this.setState({
                    dateChioseNumberStart: "endDateStart",
                    dateChioseNumberEnd: "endDateEnd"
                });
                break;
            case 3: //实际退租日
                this.setState({
                    dateChioseNumberStart: "factEndDateStart",
                    dateChioseNumberEnd: "factEndDateEnd"
                });
                break;
            case 4: //签约日
                this.setState({
                    dateChioseNumberStart: "createTimeStart",
                    dateChioseNumberEnd: "createTimeEnd"
                });
                break;
            default: 
                break;
        }
    }

    handleGetRentUrl = (id) => {
        postFrom({ url: config.API_rentcontract_getMerchantSignUrl, data: { rentContractId: id, } }).then(res => {
            if (res) {
                res = JSON.parse(res);
                message.success(res.shortUrl, 5);
            } else {
                message.error('解析地址失败');
            }
        }).catch(err => {
            message.error(err.message || '获取地址失败');
        });
    }

    handleGetImportLog = (id) => {  //获取批量导入合同的异步进程日志
        this.setState({logImporLoad:true})
        this.logTimer = setInterval(()=>{
            postFrom({ url: config.API_rentcontract_getImportLog, data: { threadNo: id, } }).then(res => {
                if (res) {
                    this.setState({logImporLoad:false,logImportData:res.replace(/\\r\\n/g,'\n')})
                } else {
                    message.error(res.message ||  '操作失败!');
                    clearInterval(this.logTimer)
                }
            }).catch(err => {
                message.error(err.message || '操作异常!');
                clearInterval(this.logTimer)
            });
        },2000)
    }

    closeLogImport = ()=>{  //清除 批量合同导入定时器
        clearInterval(this.logTimer)
        this.handleSearch()
        this.setState({showLogImportModal:false})
    }

    importProps = { //批量合同导入
        action: config.API_rentcontract_importRentContract,
        accept: '.xls',
        showUploadList: false,
        beforeUpload: (file) => {
            message.loading(`${file.name}上传中...`);
        },
        onChange: (info) => {
            if (info.file.status === 'done') {
                let res = info.file.response;
                if (res.code === 0) {
                    message.success(`${info.file.name}文件导入成功`);
                    if(res.data){
                        this.setState({showLogImportModal:true})
                        this.handleGetImportLog(res.data)
                    }
                } else {
                    if(Array.isArray(res.data)){
                        Modal.error({
                            className:'importModal',
                            title: res.message || `${info.file.name}文件导入失败`,
                            content: <div style={{whiteSpace:'pre',maxHeight:'80vh',overflow:'auto'}}>{res.data.join('\n')}</div> ,
                        });
                    }else{
                        message.error(res.message || `${info.file.name}文件导入失败`);
                    }
                }
            } else if (info.file.status === 'error') {
                message.error(`${info.file.name}文件上传失败`);
            }
        },
    };

    handleGetBillImportLog = (id) => {  //获取批量导入账单的异步进程日志
        this.setState({billImporLoad:true})
        this.billTimer = setInterval(()=>{
            postFrom({ url: config.API_bill_getImportLog, data: { threadNo: id, } }).then(res => {
                if (res) {
                    this.setState({billImporLoad:false,billImportData:res.replace(/\\r\\n/g,'\n')})
                } else {
                    message.error(res.message ||  '操作失败!');
                    clearInterval(this.billTimer)
                }
            }).catch(err => {
                message.error(err.message || '操作异常!');
                clearInterval(this.billTimer)
            });
        },2000)
    }

    closeBillImport = ()=>{  //清除 批量账单导入定时器
        clearInterval(this.billTimer)
        this.handleSearch()
        this.setState({showBillImportModal:false})
    }

    importBillProps = { //批量账单导入
        action: config.API_bill_importBill,
        accept: '.xls',
        showUploadList: false,
        beforeUpload: (file) => {
            message.loading(`${file.name}上传中...`);
        },
        onChange: (info) => {
            if (info.file.status === 'done') {
                let res = info.file.response;
                if (res.code === 0) {
                    message.success(`${info.file.name}文件导入成功`);
                    if(res.data){
                        this.setState({showBillImportModal:true})
                        this.handleGetBillImportLog(res.data)
                    }
                } else {
                    if(Array.isArray(res.data)){
                        Modal.error({
                            className:'importModal',
                            title: res.message || `${info.file.name}文件导入失败`,
                            content: <div style={{whiteSpace:'pre',maxHeight:'80vh',overflow:'auto'}}>{res.data.join('\n')}</div> ,
                        });
                    }else{
                        message.error(res.message || `${info.file.name}文件导入失败`);
                    }
                }
            } else if (info.file.status === 'error') {
                message.error(`${info.file.name}文件上传失败`);
            }
        },
    };

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            showAddBillModal,
            inputSearchTerm,
            showCheckOutModal,
            showDeleteModal,
            dateChioseNumberStart,
            dateChioseNumberEnd,
            showAddModal,
            tableTotalMny
        } = this.state;

        this.importProps.headers = { ...(handleExportParams() || {}) };

        this.importBillProps.headers = { ...(handleExportParams() || {}) };
        let column= columns({ 
            handleSendMessage: this.handleSendMessage, 
            handleAddBill: this.handleAddBill, 
            handleCheckOut: this.handleCheckOut,
            handleDelete: this.handleDelete, 
            dateChioseNumberStart, 
            dateChioseNumberEnd,
            hangleWatchDetail: this.hangleWatchDetail, 
            handleGetRentUrl: this.handleGetRentUrl , 
            handleSearch:this.handleSearch,
            handleRenewal: this.handleRenewal,
            handleJrApiLogInfo:this.handleJrApiLogInfo.bind(this) 
        });

      /*  column=column.filter(e =>{
            //判断平台，如果是平台则返回true 商户则不显示同步状态及建融Id
             if(isPlatform()){
                 return true;
             }
             return e.dataIndex!='name33';
        });*/

        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper search-wrapper-two" style={{ flexDirection: 'column', }}>
                    <SuperForm
                        data={searchData({ inputSearchTerm, handleRangeDate: this.handleRangeDate, dateChioseNumberStart, dateChioseNumberEnd })}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                    />

                </div>
                <TableDOM
                    columns={column}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    totalMny={tableTotalMny}
                    current={current}
                    onChange={this.handleSearch}
                />
                <AddBill
                    onRef={ref => this.addBillRef = ref}
                    visible={showAddBillModal}
                    handleCancel={() => { this.setState({ showAddBillModal: false }) }}
                    handleGetList={this.handleSearch}
                />
                <CheckOut
                    onRef={ref => this.checkOutRef = ref}
                    visible={showCheckOutModal}
                    handleCancel={() => { this.setState({ showCheckOutModal: false }) }}
                    handleGetList={this.handleSearch}
                />
                <Delete
                    onRef={ref => this.deleteRef = ref}
                    visible={showDeleteModal}
                    handleCancel={() => { this.setState({ showDeleteModal: false }) }}
                    handleGetList={this.handleSearch}
                />
                <Details
                    onRef={ref => this.ListDetailsRef = ref}
                    visible={showAddModal}
                    handleCancel={() => { this.setState({ showAddModal: false }) }}
                />
                <LeaseSigning 
                    onRef={ ref => this.LeaseSigningRef = ref }
                />

                {/* 批量合同导入 */}
                <Modal
                    destroyOnClose
                    maskClosable={false}
                    visible={this.state.showLogImportModal}
                    onCancel={this.closeLogImport}
                    footer={<Button onClick={this.closeLogImport} type="primary">确定</Button>}
                >
                    <Spin spinning={this.state.logImporLoad}>
                        <div style={{maxHeight:'80vh',overflow:'auto',padding:'30px',whiteSpace:'pre'}}>
                            {this.state.logImportData}
                        </div>
                    </Spin>
                </Modal>
                {/* 批量账单导入 */}
                <Modal
                    destroyOnClose
                    maskClosable={false}
                    visible={this.state.showBillImportModal}
                    onCancel={this.closeBillImport}
                    footer={<Button onClick={this.closeBillImport} type="primary">确定</Button>}
                >
                    <Spin spinning={this.state.billImporLoad}>
                        <div style={{maxHeight:'80vh',overflow:'auto',padding:'30px',whiteSpace:'pre'}}>
                            {this.state.billImportData}
                        </div>
                    </Spin>
                </Modal>

                <JrApiLog ref={ref=>{ this.jrApiLogRef=ref; }} />
            </PageWrap>
        )
    }
}

const searchData = ({ inputSearchTerm, handleRangeDate, dateChioseNumberStart, dateChioseNumberEnd }) => {
    let data = [
        {
            tagName: 'Input',
            formConfig: { name: 'merchantName' },
            attribute: { placeholder: '输入商户简称', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'Input',
            formConfig: { name: 'projectName' },
            attribute: { placeholder: '输入项目', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'Input',
            formConfig: { name: 'buildingName' },
            attribute: { placeholder: '输入楼栋', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'Input',
            formConfig: { name: 'roomNo' },
            attribute: { placeholder: '输入房号', style: { width: inputSearchTerm } }
        },
        {
            tagName: 'Select',
            formConfig: { name: 'RentContractContractType' },
            attribute: { placeholder: '请选择合同类型', style: { width: inputSearchTerm } },
            optionData: [{ title: '全部', value: '' }].concat(contractType), //.concat(dicHouseStatus)
            notResult: '',
        },
        {
            tagName: 'InputTip',
            formConfig: { name: 'keyword' },
            attribute: { placeholder: '输入关键字', style: { width: inputSearchTerm } },
            title: '在租客、手机号、签约人内模糊查询'
        },
        {
            tagName: 'Select',
            formConfig: { name: 'notUsed' },
            attribute: { placeholder: '请选择日期类别', style: { width: inputSearchTerm }, onChange: handleRangeDate },
            optionData: [{ title: '合同起租日', value: 1 },  { title: '签约日', value: 4 }],
            notResult: ''
        },
        {
            tagName: 'DatePicker',
            formConfig: { name: dateChioseNumberStart || 'beginDateStart' },
            attribute: { placeholder: '请选择开始日期', style: { width: inputSearchTerm } },
        },
        {
            tagName: 'DatePicker',
            formConfig: { name: dateChioseNumberEnd || 'beginDateEnd' },
            attribute: { placeholder: '请选择结束日期', style: { width: inputSearchTerm } },
        },
        {
            tagName: 'Select',
            formConfig: { name: 'signStatus' },
            attribute: { placeholder: '请选择签约状态', style: { width: inputSearchTerm } },
            optionData: [{ title: '全部', value: '' }].concat(dicRentContractSignStatus), //.concat(dicHouseStatus)
            notResult: '',
        },

    ];

    //判断是否平台，未平台则把syncStatus=> 同步状态 及商户简称查询查询条件取消

        data = data.filter(e => {
            if(isPlatform()){
                return true;
            }
            if (e.formConfig.name === 'merchantName') {
                return false;
            }
            return true;
        });

    return data;
};
const columns = ({ handleAddBill, handleCheckOut, handleDelete, handleSendMessage, hangleWatchDetail, handleGetRentUrlm,handleSearch,handleJrApiLogInfo, handleRenewal }) => [
    {
        title: '到期日期',
        dataIndex: 'endDate',
        render(text, record, index) {
            return <span>
                <div>{text ? moment(text).format('YYYY-MM-DD') : ''}</div>
                {record.overdueDays > 0 ? <div style={{ color: 'red' }}>逾期{record.overdueDays}天</div> : ''}
            </span>
        }
    },
    {
        title: '租赁状态 | 来源',
        dataIndex: 'rentStatus',
        render(text, record, index) {
            let rentStatus = dicRentContractRentStatus.find(item => item.value === text);
            let contract = contractSource.find(item => item.value === record.contractSource);
            return <span>
                    <div style={{ color: rentStatus.color }}>{rentStatus.title}</div>
                    <div style={{ color: contract.color }}>{contract.title}</div>
                </span>
        }
    },
    {
        title: '签约类型',
        dataIndex: 'signStatus',
        render(text, record, index) {
            return <span>
                <div>{record.contractType ? record.contractType === 1 ? "电子" : record.contractType === 2 ? "纸质" : "" : ""}</div>
                <div style={{ color: "red" }}>
                    {
                        record.merchantSigned === true && record.customerSigned === true
                            ? '已签'
                            : <React.Fragment>
                                <span style={{ marginRight: '10px' }}>{record.customerSigned === true ? "租客已签" : record.customerSigned === false ? "租客未签" : ""}</span>
                                {record.merchantSigned === true ? "商户已签" : record.merchantSigned === false ? "商户未签" : ""}
                            </React.Fragment>
                    }
                </div>
            </span>
        }
    },
    {
        title: '房源',
        dataIndex: 'houseId',

        render(text, record, index) {
            return <span>
                <div>{record.roomNo ? record.roomNo : ''}</div>
                <div>{record.buildingName ? record.buildingName : ''}</div>
            </span>
        }
    },
    {
        title: '租客',
        dataIndex: 'customerName',
        render(text, record, index) {
            return <span>
                <div>{record.customerName ? record.customerName : ""}</div>
                <div>{record.customerPhone ? record.customerPhone : ""}</div>
            </span>
        }
    },
    {
        title: '合同周期',
        dataIndex: 'n34ame',

        render(text, record, index) {
            return <span>
                <div>{record.beginDate ? moment(record.beginDate).format('YYYY-MM-DD') : ''}</div>
                <div>{record.endDate ? moment(record.endDate).format('YYYY-MM-DD') : ''}</div>
            </span>
        }

    },
    {
        title: '租金（元）',
        dataIndex: 'monthlyFee',
        align: 'right',
        render(text, record, index) {
            return <span style={{ textAlign: "right" }}>
                <div>{moneyAddComma(record.monthlyFee)}</div>
            </span>
        }
    },
    {
        title: '办理人 | 时间',

        dataIndex: 'name32',
        render(text, record, index) {
            return <span>
                <div>{record.createMerchantUserName ? record.createMerchantUserName : ""}</div>
                {
                    record.createTime
                        ? <React.Fragment>
                            <div>{record.createTime ? moment(record.createTime).format('YYYY-MM-DD') : ''}</div>
                        </React.Fragment>
                        : null
                }
            </span>
        }
    },
    {
        title: '商户 | 项目',
        dataIndex: 'name12',

        render(text, record, index) {
            return <span>
                <div>{record.shortName}</div>
                {
                    record.projectName
                        ? <React.Fragment>
                            <div>{record.projectName}</div>
                        </React.Fragment>
                        : null
                }
            </span>
        }

    },
    {
        title: '操作',
        dataIndex: 'action',
        // width: 200,
        render:(text, record, index) => {
            const moreMenu = (
                <Menu>
                    <AuthButton authkey="d-10-9"><div className="ant-dropdown-menu-item" onClick={() => { handleCheckOut(record.id) }}>退租</div></AuthButton>
                    <AuthButton authkey="d-10-16"><div className="ant-dropdown-menu-item" onClick={() => { handleRenewal(record) }}>续签</div></AuthButton>
                    <AuthButton authkey="d-10-4"><div className="ant-dropdown-menu-item" onClick={() => { handleDelete(record.id) }}>删除</div></AuthButton>
                </Menu>
            );
            let authArr = ['d-10-9','d-10-4','d-10-16']

            return (
                <div className="table-action">
                    <AuthButton authkey="d-1-2"><span className="showClickDetail" onClick={() => { hangleWatchDetail({ id: record.id }) }} >详情</span></AuthButton>
                    {
                        record.rentStatus === 1 ? 
                                <AuthButton authkey={authArr}>
                                <Dropdown overlay={moreMenu}>
                                    <span><Icon type="down" /></span>
                                </Dropdown>
                                </AuthButton>
                            : null
                    }
                </div>
            )
        }
    }
];



// WEBPACK FOOTER //
// ./src/page/RentContract/expireList.js